<template>
  <ProgressBar
    :modelValue="inCount"
    :maxValue="spotCount"
    :label="progressLabel"
    :isDisabled="!!run.canceled_at"
    v-bind="{isReady}"
  />
</template>

<script lang="ts" setup>
import ProgressBar from "@/components/ProgressBar.vue";
import useRun from "@/composables/useRun";
import { CourtSummary, CrewSummary, RunSummary, Status } from "@shared/lib/database/query.types";
import { computed, toRefs } from "vue";

type RunForProgressBar = RunSummary & {
  statuses: Array<Pick<Status, "probability">>,
  crews: Array<CrewSummary>,
  court: CourtSummary | null,
};

const props = defineProps<{
  run: RunForProgressBar,
  isReady: boolean,
}>();

const {
  run,
} = toRefs(props);

// TODO: useRunCount
const {
  inCount,
  spotCount,
  isGameOn,
} = useRun(run);

const progressLabel = computed(() => {
  if (run.value?.canceled_at) return "Canceled";
  if (isGameOn.value) return "Game on!";

  return "";
});
</script>
